<template>
    <layout-general-container spaceToolbar>
        <div class="w-full flex justify-center">
            <div class="w-full flex flex-col gap-10">
                <div
                    class="bg-banner-1 h-[40vh] border-b px-6 flex flex-col gap-8 items-center justify-center text-center w-full">
                    <h1 class="text-white text-4xl font-semibold tracking-wide">Our Partners</h1>
                    <h2 class="text-white tracking-wide leading-loose md:max-w-6xl font-light">Meet our valued partners who help us drive innovation and empower social enterprises in reaching their full potential.</h2>
                </div>
                <div class="w-full px-6 md:px-8 xl:px-14 flex-col flex gap-8 bg-white">
                    <div class="flex flex-row items-center gap-3">
                        <span class="text-sm font-medium min-w-max">Category :</span>
                        <a-select class="w-full md:w-[16rem]" :id="'client-filter-category'" @change="fetchClients()" v-model:value="selectedCategory">
                            <template #suffixIcon>
                                <IconCategory2 :size="18" />
                            </template>

                            <a-select-option :value="''">-- All Category --</a-select-option>
                            <a-select-option v-for="option in categoryOptions" :key="option" :value="option">{{ option }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="grid w-full grid-cols-2 xl:grid-cols-4 gap-6 md:gap-8 xl:gap-12">
                        <div v-for="(item, index) in clients" :key="index" class="flex flex-col gap-3">
                            <div class="h-[14rem] md:h-[15rem] items-center justify-center flex relative">
                                <div class="absolute bg-black opacity-5 h-[14rem] md:h-[15rem] w-full"></div>
                                <img :src="item.logo" class="w-full object-contain h-[10rem]" alt="">
                            </div>
                            <div class="flex flex-row w-full justify-between">
                                <div class="flex flex-col gap-1">
                                    <span class="text-lg font-semibold text-primary">{{ item.name }}</span>
                                    <span class="text-base text-light">{{ item.category }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout-general-container>
</template>
  
<script setup>
import { onMounted, ref } from 'vue'
import { IconArrowRight, IconSearch, IconSortDescending, IconCategory2, IconChartDonut, IconCalendarMonth, IconTrophy, IconAlarm, IconHourglassEmpty, IconCertificate2, IconRotateClockwise2 } from '@tabler/icons-vue'
import Client1 from "@/assets/img/client/1.png"
import Client2 from "@/assets/img/client/2.png"
import Client3 from "@/assets/img/client/3.png"
import Client4 from "@/assets/img/client/4.png"
import Client5 from "@/assets/img/client/5.jpeg"
import Client6 from "@/assets/img/client/6.png"
import Client7 from "@/assets/img/client/7.png"
import Client8 from "@/assets/img/client/8.png"
import axios from "@/plugins/axios";

// const clients = ref([
//     {
//         name: "Hyundai Motor Group",
//         image: Client1,
//         category: "Corporate"
//     },
//     {
//         name: "Telkomsel",
//         image: Client2,
//         category: "Corporate"
//     },
//     {
//         name: "DBS Foundation",
//         image: Client3,
//         category: "Corporate"
//     },
//     {
//         name: "The Meloy Fund",
//         image: Client4,
//         category: "Investor"
//     },
//     {
//         name: "Phitrust",
//         image: Client5,
//         category: "Investor"
//     },
//     {
//         name: "Ayobantu.com",
//         image: Client6,
//         category: "Enterprise"
//     },
//     {
//         name: "Kementerian PPN/Bappenas",
//         image: Client7,
//         category: "Goverment"
//     },
//     {
//         name: "UNDP Indonesia",
//         image: Client8,
//         category: "Goverment"
//     },


// ])
const clients = ref([])
const categoryOptions = ref([]);
const selectedCategory = ref('');

const fetchCategoryOptions = async () => {
    try {
        const response = await axios.get('/partners/filter-option');

        categoryOptions.value = response.data;
        // console.log('Category options fetched:', categoryOptions.value);
    } catch (error) {
        console.error('Failed to fetch category options:', error);
    }
};

const fetchClients = async () => {
    // console.log('hahajaj')
    try {
        const response = await axios.get('/partners', {
            params: {
                category: selectedCategory.value
            }
        });

        clients.value = response.data.data;
    } catch (error) {
        console.error('Failed to fetch clients:', error);
    }
};

onMounted(() => {
    fetchCategoryOptions();
    fetchClients();
});
</script>
  
